module.exports = __webpack_public_path__ + "media/brands/access-a8fa16f8.png";